export default class ArchiveProgramsPage {
	constructor() {
		// Set show event
		this.addShowEvent();
		// Also check for results right away
		this.showResults();

		// Set class variables.
		this.mobileMenuToggle = document.querySelector( '.js-program-archive-mobile-menu-button' );

		// Bail early if we aren't on the program archives.
		if ( ! this.mobileMenuToggle ) {
			return;
		}

		this.isMobileMenuOpen = false;
		this.sidebar = document.querySelector( '.js-program-archive-sidebar' );
		this.mobileMenuToggleText = this.mobileMenuToggle.querySelector( '.js-program-archive-mobile-menu-button-text' );

		// Constants
		this.IS_MENU_OPEN_CLASS = 'is-open';
		this.IS_MENU_CLOSED_CLASS = 'is-closed';
		this.IS_MENU_CLOSED_ON_MOBILE_CLASS = 'is-closed-on-mobile';
		this.SHOW_FILTERS_TEXT = this.mobileMenuToggleText?.innerHTML ?? 'Filtrera';
		this.HIDE_FILTERS_TEXT = this.mobileMenuToggle?.dataset.closeText ?? 'Stäng';

		this.addToggleEvent();
	}

	/**
	 * Add event listener for showing our results.
	 */
	addShowEvent = () => {
		document.addEventListener( 'facetwp-loaded', this.showResults );
	};

	/**
	 * Add event listener for toggling mobile menu.
	 */
	addToggleEvent = () => {
		this.mobileMenuToggle.addEventListener( 'click', this.toggleMenu );
	};

	/**
	 * Toggles the mobile menu.
	 */
	toggleMenu = () => {
		if ( this.isMobileMenuOpen ) {
			this.closeMenu();
		} else {
			this.openMenu();
		}
	};

	/**
	 * Opens the mobile menu.
	 */
	openMenu = () => {
		// Bail early if we aren't on the program archives.
		if ( ! this.mobileMenuToggle ) {
			return;
		}
		this.mobileMenuToggleText.innerHTML = this.HIDE_FILTERS_TEXT;
		this.mobileMenuToggle?.classList.add( this.IS_MENU_OPEN_CLASS );
		this.mobileMenuToggle?.classList.remove( this.IS_MENU_CLOSED_CLASS );
		this.sidebar?.classList.remove( this.IS_MENU_CLOSED_ON_MOBILE_CLASS );
		this.isMobileMenuOpen = true;
	};

	/**
	 * Closes the mobile menu.
	 */
	closeMenu = () => {
		// Bail early if we aren't on the program archives.
		if ( ! this.mobileMenuToggle ) {
			return;
		}
		this.mobileMenuToggleText.innerHTML = this.SHOW_FILTERS_TEXT;
		this.mobileMenuToggle?.classList.remove( this.IS_MENU_OPEN_CLASS );
		this.mobileMenuToggle?.classList.add( this.IS_MENU_CLOSED_CLASS );
		this.sidebar?.classList.add( this.IS_MENU_CLOSED_ON_MOBILE_CLASS );
		this.isMobileMenuOpen = false;
	};

	/**
	 * Show our results once we have a filter selection.
	 */
	showResults = () => {
		const results = document.querySelector( '.js-program-archive-results' );
		// Unhide the results container when the page loads (it's hidden by default to prevent a flash of unstyled content), and could be hidden
		// still after this (because of FacetWP Conditional logic that hides the results until at least 1 facet is in use)
		if ( results ) {
			results.style.removeProperty( 'display' );
		}

		// Hide the mobile menu when a facet a refresh happens.
		this.closeMenu();
	};
}
